module.exports = __webpack_public_path__ + "static/media/Play_arrow.61e9a7e7.svg";